/**
 * replayMotionSemantics
 *
 * Deterministic CSS properties for replay cursor and progression motion.
 * Communicates: replay cursor movement, causal progression, window transitions.
 */

import { TRANSITION_REPLAY_CURSOR } from './motionTokens.js';

/**
 * Replay cursor indicator style.
 * Smooth deterministic interpolation between replay positions.
 */
export function replayCursorStyle(active: boolean, color: string): React.CSSProperties {
  return {
    opacity: active ? 1 : 0.3,
    transform: active ? 'translateX(0)' : 'translateX(-4px)',
    transition: TRANSITION_REPLAY_CURSOR,
    borderLeft: `2px solid ${color}`,
    backgroundColor: active ? `${color}10` : 'transparent',
  };
}

/**
 * Replay window boundary style.
 * Marks the edges of a replay window with calm fade.
 */
export function replayWindowBoundaryStyle(inWindow: boolean, color: string): React.CSSProperties {
  return {
    opacity: inWindow ? 1 : 0.4,
    transition: `opacity 200ms ease-out`,
    borderTop: inWindow ? `1px solid ${color}30` : '1px solid transparent',
    borderBottom: inWindow ? `1px solid ${color}30` : '1px solid transparent',
  };
}

/**
 * Causal progression emphasis style.
 * Emphasizes the causal chain during replay.
 */
export function causalEmphasisStyle(isCausal: boolean, color: string): React.CSSProperties {
  return {
    opacity: isCausal ? 1 : 0.5,
    borderLeft: isCausal ? `2px solid ${color}` : '2px solid transparent',
    transition: `opacity 180ms ease-out, border-color 180ms ease-out`,
  };
}
